module.exports = __webpack_public_path__ + "files/0737533eb2a9b761661054acb8a07204.png";